export default __webpack_public_path__ + "static/media/ayanAir-logo.ff1e02f7.svg";